'use client'

import { useEffect } from 'react'
import styles from './Volunteers.module.scss'
import Link from 'next/link'
// import LinkIcon from '@mui/icons-material/Link'
import Button from '@mui/material/Button'
import GoogleIcon from '@mui/icons-material/Google'
import MultiLanguage from './MultiLanguage'
import googleFormService from '@/modules/googleFormService'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import { useTranslations } from 'next-intl'

function Page () {
  const t = useTranslations('MainFooter')
  const v = useTranslations('Volunteering')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.title = v('doc-title')
    }
  }, [])


  return (
    <div className={styles.wrapper}>
      <Breadcrumbs aria-label="breadcrumb" className={styles.breadcrumb}>
        <Link
          color="inherit"
          href="/"
        >
          {t('home')}
        </Link>
        <Typography color="text.primary">
          {t('volunteering')}
        </Typography>
      </Breadcrumbs>
      <div className={styles.upperWrapper}>
        <div className={styles.innerUpperWrapper}>
          <h1 className={styles.title}>
            {v('interested')}
          </h1>
          <div className={styles.upperWrap}>
            <h2>{v('be-part')}</h2>
            <p>{v('our-goal')}</p>
          </div>
          <div className={styles.upperWrap}>
            <h2>{v('invest-in')}</h2>
            <p>{v('your-work')}</p>
          </div>
        </div>
        <div className={styles.innerUpperWrapper}>
          <p>{v('by-filling')}</p>
          <div className={styles.linkWrapper}>
            <Link href={googleFormService('volunteerApplication')} target='_blank'>
              <Button
                variant={'contained'}
                startIcon={<GoogleIcon />}
                endIcon={<OpenInNewIcon />}
                style={{ textTransform: 'none' }}
              >
                {v('volunteer-application-button')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.volunteerWrapper}>
        <div className={styles.translatorVolunteer}>
          <h2>{v('interested-in-translating')}</h2>
          <p>{v('if-bilingual')}</p>
          <div className={styles.linkWrapper}>
            <Link href={googleFormService('translationTraining')} target='_blank'>
              <Button
                variant={'outlined'}
                startIcon={<GoogleIcon />}
                endIcon={<OpenInNewIcon />}
                style={{ textTransform: 'none' }}
              >
                {v('translation-training-request-button')}
              </Button>
            </Link>
          </div>
          <div>
            <MultiLanguage />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page
